export const buildTreatmentDetailSlug = (medicalTreatmentSlug: string) =>
  `TREATMENT-DETAILS-${medicalTreatmentSlug.toUpperCase()}`
